module.exports = __webpack_public_path__ + "img/mobile_product1.254e6001.png";